import {AppTableConfig} from "@shared/components/app-table/app-table.interfaces";
import {TABLE_CONFIG_DEFAULT} from "@app/ng-zorro/nz-config/nz-common.config";

export class ReportConstant {

  private static HEADER_TABLE_BASE = [
    {
      title: 'Thời gian',
      field: 'dateOrder',
      filterTemplate: 'filter.dateOrder',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Số đơn hàng',
      field: 'totalOrder',
      pipe: 'thousand_sep',
      filterTemplate: 'filter.totalOrder',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Số tiền',
      field: 'totalAmount',
      pipe: 'currency',
      filterTemplate: 'filter.totalAmount',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 150,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    }
  ];

  public static TABLE_CONFIG: AppTableConfig = {
    headers: [...ReportConstant.HEADER_TABLE_BASE],
    total: 0,
    needScroll: true,
    loading: false,
    pageSize: TABLE_CONFIG_DEFAULT.pageSize,
    pageIndex: 1,
    size: 'small',
    showCheckbox: false,
    showFrontPagination: false,
    showId: true,
    bordered: true,
    showSizeChanger: true,
    showFilter: true
  };
}
